import React from 'react';
import { Props } from './additionalInformation.type';
import { Card, CardBody } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';

const Item = ({
  label,
  value = '-',
  copyToClipboard
}: {
  label: string;
  value?: string | number;
  copyToClipboard?: boolean;
}) => {
  return (
    <div className="mb-2">
      <p className="m-0 fw-bold">{label}</p>
      <p className="m-0 w-100 d-flex justify-content-between align-items-center">
        <span>{value}</span>
        {copyToClipboard && (
          <FontAwesomeIcon icon={faCopy} className="cursor-pointer ms-2" />
        )}
      </p>
    </div>
  );
};

function AdditionalInformation({ data }: Props) {
  return (
    <>
      <h4 className="mb-3">Additional Info</h4>
      <Card className="mb-2">
        <CardBody>
          <h5 className="mb-3">Contact Details</h5>
          <Item label="Name" value={data?.contactPersonName} />
          <Item
            label="Email Address"
            value={data?.contactPersonEmail}
            copyToClipboard
          />
        </CardBody>
      </Card>
      <Card className="mb-2">
        <CardBody>
          <h5 className="mb-3">Application Details</h5>
          <Item
            label="Deadline"
            value={
              data?.deadline ? dayjs(data.deadline).format('DD MMM YYYY') : ''
            }
          />
          <Item
            label="Link / Email"
            value={data?.linkOrEmail}
            copyToClipboard
          />
          <Item
            label="Number of openings"
            value={data?.numberOfOpenings}
            copyToClipboard
          />
        </CardBody>
      </Card>
      <Card className="mb-2">
        <CardBody>
          <h5 className="mb-3">Supplementary Details</h5>
          <Item label="Working Hours" value={data?.workingHours} />
          <Item label="Benefits" value={data?.benefits} />
        </CardBody>
      </Card>
    </>
  );
}

export default AdditionalInformation;
